import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
Vue.use(Router)


const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
       path:'/',
       name:'index',
       meta:{
         requireAuth:false,
         title:'阿哈路书-让自驾更简单',
       },
       component: () => import('@/views/home/index.vue'),
    },
    {
       path:'/news/index',
       name:'index',
       meta:{
         requireAuth:false,
         title:'阿哈路书-新闻资讯',
       },
       component: () => import('@/views/news/index.vue'),
    },
    {
       path:'/news/info/:id',
       name:'info',
       props: true,
       meta:{
         requireAuth:false,
         title:'阿哈路书-新闻详情',
       },
       component: () => import('@/views/news/info.vue'),
    },
    {
       path:'/about/index',
       name:'index',
       meta:{
         requireAuth:false,
         title:'阿哈路书—关于阿哈',
       },
       component: () => import('@/views/about/index.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js